import * as types from './action-types';

const baseState = {
    hasError: false,
    error: null,
    fetching: false,
};

const defaultState = {
    ...baseState,
    leadRegistration: {},
};

const reducer = (state = defaultState, action) => {
    switch (action.type) {
    case types.LEADREGISTRATION_PENDING:
        return Object.assign({}, state, baseState, {
            fetching: true,
        });

    case types.LEADREGISTRATION_FAILED:
        return Object.assign({}, state, baseState, {
            hasError: true,
            error: action.error,
        });

    case types.LEADREGISTRATION_SUCCESS:
        return Object.assign({}, state, baseState, {
            leadRegistration: action.res.data,
        });

    default:
        return Object.assign({}, state);
    }
};

export default reducer;
